<template>
    <div>
        <b-row>
            <b-col sm="9">
                <router-view></router-view>
            </b-col>
            <b-col>
                <b-card :no-body="true">
                    <b-card-body class="p-2 clearfix">
                        <i class="fa-duotone fa-users bg-secondary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h4 mb-0 mt-2">
                            <b-link to="/settings/users">Permissions</b-link>
                        </div>
                    </b-card-body>
                </b-card>

<!--                <b-card :no-body="true">-->
<!--                    <b-card-body class="p-2 clearfix">-->
<!--                        <i class="fa-duotone fa-boxes bg-secondary p-3 font-2xl mr-3 float-left"></i>-->
<!--                        <div class="h4 mb-0 mt-2">-->
<!--                            <b-link :to="{name: 'settings-inventory'}">Inventory</b-link>-->
<!--                        </div>-->
<!--                    </b-card-body>-->
<!--                </b-card>-->
<!--                <b-card :no-body="true">-->
<!--                    <b-card-body class="p-2 clearfix">-->
<!--                        <i class="fa-duotone fa-cogs bg-secondary p-3 font-2xl mr-3 float-left"></i>-->
<!--                        <div class="h4 mb-0 mt-2">-->
<!--                            <b-link :to="{name: 'settings-system'}">System</b-link>-->
<!--                        </div>-->
<!--                    </b-card-body>-->
<!--                </b-card>-->

                <b-card :no-body="true">
                    <b-card-body class="p-2 clearfix">
                        <i class="fa-duotone fa-money-bill-alt bg-secondary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h4 mb-0 mt-2">
                            <b-link to="/settings/rates">Rates</b-link>
                        </div>
                    </b-card-body>
                </b-card>

                <b-card :no-body="true">
                    <b-card-body class="p-2 clearfix">
                        <i class="fa-duotone fa-truck-fast bg-secondary p-3 font-2xl mr-3 float-left"></i>
                        <div class="h4 mb-0 mt-2">
                            <b-link to="/settings/fulfillment">Fulfillment Centers</b-link>
                        </div>
                    </b-card-body>
                </b-card>

                <label class="mb-2">Order:</label>
                <b-input type="number" class="mb-2" v-model="inputOrder"></b-input>
                <b-button @click="printIntakeLabels" block :disabled="printing">Print Intake Labels <i v-if="printing" class="fa-regular fa-spinner fa-spin fa-fw"></i></b-button>
                <div v-if="printing">{{ printingMessage }}</div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'settings-index',
        title: 'Settings',
        data() {
            return {
                inputOrder: null,
                printing: false,
                printingMessage: null,
            };
        },
        created() {
            this.$qz.connect().then(() => {
            });
            //FIXME move this to a button
            this.$store.commit('FORCE_CACHE_BUST');
        },
        methods: {
            printLabel(order, i,l) {
                let printData = '^XA\n' +
                    '^LH0,0\n' +
                    '^CF0,30,30\n' +
                    '^PW609\n' +
                    '~SD7\n' +
                    '\n' +
                    '^PON\n' +
                    '\n' +
                    '^FO20,20\n' +
                    '^FB609,2,0,C\n' +
                    '^FDORDER:' + order.order + '^FS' +
                    '^FO20,80\n' +
                    '^AO\n' +
                    '^FB609,2,0,C\n' +
                    '^FDDEMO TRACKING:' + order.tracking_number + '^FS' +
                    '^FO60,200\n' +
                    '^BY3,3\n' +
                    '^B3N,N,120,N\n' +
                    '^FD' + order.tracking_number + '^FS' +
                    '^PQ1\n' +
                    '^XZ';
                this.$printer.printRaw('zebra', printData).then(() => {
                    this.printingMessage = 'Printing Label ' + i + ' of ' + l;
                    if (i === l) {
                        this.printing = false;
                    }
                });
            },
            printIntakeLabels() {
                this.printing = true;
                this.printingMessage = 'Printing Labels ...';
                if(this.inputOrder) {
                    this.$http.get('/orders/' + this.inputOrder + '?include=trackingNumbers')
                        .then(response => {
                            let order  = response.data.data;
                            console.log(response);
                            if(order && order.trackingNumbers && order.trackingNumbers.length > 0) {
                                /*this.printLabel({
                                    'order': order.id,
                                    'tracking_number': order.trackingNumbers[order.trackingNumbers.length-1].tracking_number,
                                },1,1);

                                 */
                                this.$label('order',order);
                                let i;
                                for(i = 0; i < order.trackingNumbers.length; i++) {
                                    this.$label('fedex', order.trackingNumbers[i]);
                                }
                                if(i == 0){
                                    window.alert("this order has no tracking numbers");
                                }
                                this.printing = false;
                            } else {
                                window.alert("Order number not found or tracking number does not exist for this order");
                                this.printing = false;
                            }
                        });
                }

            },
        },
    };
</script>

<style scoped>

</style>
